package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.ArrowUpwardW500Rounded: ImageVector
    get() {
        if (_arrowUpwardW500Rounded != null) {
            return _arrowUpwardW500Rounded!!
        }
        _arrowUpwardW500Rounded = Builder(name = "ArrowUpwardW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(434.5f, 326.15f)
                lineTo(247.83f, 512.83f)
                quadToRelative(-13.68f, 13.67f, -32.07f, 13.29f)
                quadToRelative(-18.39f, -0.38f, -32.06f, -14.05f)
                quadToRelative(-12.68f, -13.68f, -13.06f, -32.07f)
                quadToRelative(-0.38f, -18.39f, 13.29f, -32.07f)
                lineToRelative(264.0f, -264.0f)
                quadToRelative(6.72f, -6.71f, 14.92f, -9.81f)
                quadToRelative(8.19f, -3.1f, 17.15f, -3.1f)
                quadToRelative(8.96f, 0.0f, 17.15f, 3.1f)
                quadToRelative(8.2f, 3.1f, 14.92f, 9.81f)
                lineTo(776.3f, 448.17f)
                quadToRelative(12.92f, 12.92f, 12.92f, 31.57f)
                reflectiveQuadToRelative(-12.92f, 32.33f)
                quadToRelative(-13.67f, 13.67f, -32.44f, 13.67f)
                quadToRelative(-18.77f, 0.0f, -32.45f, -13.67f)
                lineTo(525.5f, 326.15f)
                verticalLineToRelative(436.48f)
                quadToRelative(0.0f, 19.15f, -13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                reflectiveQuadToRelative(-32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                verticalLineToRelative(-436.48f)
                close()
            }
        }
        .build()
        return _arrowUpwardW500Rounded!!
    }

private var _arrowUpwardW500Rounded: ImageVector? = null
